var map = {
	"./ajax-loader.gif": "./public/assets/images/ajax-loader.gif",
	"./alert/balance.png": "./public/assets/images/alert/balance.png",
	"./alert/learning.png": "./public/assets/images/alert/learning.png",
	"./alert/social.png": "./public/assets/images/alert/social.png",
	"./apexchart/radial-image.png": "./public/assets/images/apexchart/radial-image.png",
	"./avtar/10.jpg": "./public/assets/images/avtar/10.jpg",
	"./avtar/11.jpg": "./public/assets/images/avtar/11.jpg",
	"./avtar/12.jpg": "./public/assets/images/avtar/12.jpg",
	"./avtar/13.jpg": "./public/assets/images/avtar/13.jpg",
	"./avtar/14.jpg": "./public/assets/images/avtar/14.jpg",
	"./avtar/15.jpg": "./public/assets/images/avtar/15.jpg",
	"./avtar/16.jpg": "./public/assets/images/avtar/16.jpg",
	"./avtar/17.jpg": "./public/assets/images/avtar/17.jpg",
	"./avtar/18.jpg": "./public/assets/images/avtar/18.jpg",
	"./avtar/19.jpg": "./public/assets/images/avtar/19.jpg",
	"./avtar/2.jpg": "./public/assets/images/avtar/2.jpg",
	"./avtar/20.jpg": "./public/assets/images/avtar/20.jpg",
	"./avtar/21.jpg": "./public/assets/images/avtar/21.jpg",
	"./avtar/22.jpg": "./public/assets/images/avtar/22.jpg",
	"./avtar/23.jpg": "./public/assets/images/avtar/23.jpg",
	"./avtar/24.jpg": "./public/assets/images/avtar/24.jpg",
	"./avtar/3.jpg": "./public/assets/images/avtar/3.jpg",
	"./avtar/4.jpg": "./public/assets/images/avtar/4.jpg",
	"./avtar/7.jpg": "./public/assets/images/avtar/7.jpg",
	"./avtar/8.jpg": "./public/assets/images/avtar/8.jpg",
	"./avtar/default-user.png": "./public/assets/images/avtar/default-user.png",
	"./banner/1.jpg": "./public/assets/images/banner/1.jpg",
	"./banner/2.jpg": "./public/assets/images/banner/2.jpg",
	"./banner/3.jpg": "./public/assets/images/banner/3.jpg",
	"./bg6.jpg": "./public/assets/images/bg6.jpg",
	"./big-lightgallry/01.jpg": "./public/assets/images/big-lightgallry/01.jpg",
	"./big-lightgallry/010.jpg": "./public/assets/images/big-lightgallry/010.jpg",
	"./big-lightgallry/011.jpg": "./public/assets/images/big-lightgallry/011.jpg",
	"./big-lightgallry/012.jpg": "./public/assets/images/big-lightgallry/012.jpg",
	"./big-lightgallry/013.jpg": "./public/assets/images/big-lightgallry/013.jpg",
	"./big-lightgallry/014.jpg": "./public/assets/images/big-lightgallry/014.jpg",
	"./big-lightgallry/015.jpg": "./public/assets/images/big-lightgallry/015.jpg",
	"./big-lightgallry/016.jpg": "./public/assets/images/big-lightgallry/016.jpg",
	"./big-lightgallry/02.jpg": "./public/assets/images/big-lightgallry/02.jpg",
	"./big-lightgallry/03.jpg": "./public/assets/images/big-lightgallry/03.jpg",
	"./big-lightgallry/04.jpg": "./public/assets/images/big-lightgallry/04.jpg",
	"./big-lightgallry/05.jpg": "./public/assets/images/big-lightgallry/05.jpg",
	"./big-lightgallry/06.jpg": "./public/assets/images/big-lightgallry/06.jpg",
	"./big-lightgallry/07.jpg": "./public/assets/images/big-lightgallry/07.jpg",
	"./big-lightgallry/08.jpg": "./public/assets/images/big-lightgallry/08.jpg",
	"./big-lightgallry/09.jpg": "./public/assets/images/big-lightgallry/09.jpg",
	"./big-masonry/1.jpg": "./public/assets/images/big-masonry/1.jpg",
	"./big-masonry/10.jpg": "./public/assets/images/big-masonry/10.jpg",
	"./big-masonry/11.jpg": "./public/assets/images/big-masonry/11.jpg",
	"./big-masonry/12.jpg": "./public/assets/images/big-masonry/12.jpg",
	"./big-masonry/13.jpg": "./public/assets/images/big-masonry/13.jpg",
	"./big-masonry/14.jpg": "./public/assets/images/big-masonry/14.jpg",
	"./big-masonry/15.jpg": "./public/assets/images/big-masonry/15.jpg",
	"./big-masonry/2.jpg": "./public/assets/images/big-masonry/2.jpg",
	"./big-masonry/3.jpg": "./public/assets/images/big-masonry/3.jpg",
	"./big-masonry/4.jpg": "./public/assets/images/big-masonry/4.jpg",
	"./big-masonry/5.jpg": "./public/assets/images/big-masonry/5.jpg",
	"./big-masonry/6.jpg": "./public/assets/images/big-masonry/6.jpg",
	"./big-masonry/7.jpg": "./public/assets/images/big-masonry/7.jpg",
	"./big-masonry/8.jpg": "./public/assets/images/big-masonry/8.jpg",
	"./big-masonry/9.jpg": "./public/assets/images/big-masonry/9.jpg",
	"./blog/12.png": "./public/assets/images/blog/12.png",
	"./blog/14.png": "./public/assets/images/blog/14.png",
	"./blog/4.jpg": "./public/assets/images/blog/4.jpg",
	"./blog/9.jpg": "./public/assets/images/blog/9.jpg",
	"./blog/blog-2.jpg": "./public/assets/images/blog/blog-2.jpg",
	"./blog/blog-3.jpg": "./public/assets/images/blog/blog-3.jpg",
	"./blog/blog-5.jpg": "./public/assets/images/blog/blog-5.jpg",
	"./blog/blog-6.jpg": "./public/assets/images/blog/blog-6.jpg",
	"./blog/blog-single.jpg": "./public/assets/images/blog/blog-single.jpg",
	"./blog/blog.jpg": "./public/assets/images/blog/blog.jpg",
	"./blog/comment.jpg": "./public/assets/images/blog/comment.jpg",
	"./blog/img.png": "./public/assets/images/blog/img.png",
	"./calender/icon.png": "./public/assets/images/calender/icon.png",
	"./chats/shape.png": "./public/assets/images/chats/shape.png",
	"./checkout/paypal.png": "./public/assets/images/checkout/paypal.png",
	"./customizer/1.png": "./public/assets/images/customizer/1.png",
	"./customizer/2.png": "./public/assets/images/customizer/2.png",
	"./customizer/3.png": "./public/assets/images/customizer/3.png",
	"./customizer/4.png": "./public/assets/images/customizer/4.png",
	"./customizer/5.png": "./public/assets/images/customizer/5.png",
	"./dashboard-2/event.png": "./public/assets/images/dashboard-2/event.png",
	"./dashboard-2/flags/1.png": "./public/assets/images/dashboard-2/flags/1.png",
	"./dashboard-2/flags/2.png": "./public/assets/images/dashboard-2/flags/2.png",
	"./dashboard-2/flags/3.png": "./public/assets/images/dashboard-2/flags/3.png",
	"./dashboard-2/flags/4.png": "./public/assets/images/dashboard-2/flags/4.png",
	"./dashboard-2/headphones.png": "./public/assets/images/dashboard-2/headphones.png",
	"./dashboard-2/product/1.png": "./public/assets/images/dashboard-2/product/1.png",
	"./dashboard-2/product/10.png": "./public/assets/images/dashboard-2/product/10.png",
	"./dashboard-2/product/11.png": "./public/assets/images/dashboard-2/product/11.png",
	"./dashboard-2/product/12.png": "./public/assets/images/dashboard-2/product/12.png",
	"./dashboard-2/product/13.png": "./public/assets/images/dashboard-2/product/13.png",
	"./dashboard-2/product/2.png": "./public/assets/images/dashboard-2/product/2.png",
	"./dashboard-2/product/20.png": "./public/assets/images/dashboard-2/product/20.png",
	"./dashboard-2/product/21.png": "./public/assets/images/dashboard-2/product/21.png",
	"./dashboard-2/product/22.png": "./public/assets/images/dashboard-2/product/22.png",
	"./dashboard-2/product/23.png": "./public/assets/images/dashboard-2/product/23.png",
	"./dashboard-2/product/3.png": "./public/assets/images/dashboard-2/product/3.png",
	"./dashboard-2/product/4.png": "./public/assets/images/dashboard-2/product/4.png",
	"./dashboard-2/product/5.png": "./public/assets/images/dashboard-2/product/5.png",
	"./dashboard-2/product/6.png": "./public/assets/images/dashboard-2/product/6.png",
	"./dashboard-2/product/7.png": "./public/assets/images/dashboard-2/product/7.png",
	"./dashboard-2/product/8.png": "./public/assets/images/dashboard-2/product/8.png",
	"./dashboard-2/product/9.png": "./public/assets/images/dashboard-2/product/9.png",
	"./dashboard-2/user/1.png": "./public/assets/images/dashboard-2/user/1.png",
	"./dashboard-2/user/10.png": "./public/assets/images/dashboard-2/user/10.png",
	"./dashboard-2/user/11.png": "./public/assets/images/dashboard-2/user/11.png",
	"./dashboard-2/user/2.png": "./public/assets/images/dashboard-2/user/2.png",
	"./dashboard-2/user/3.png": "./public/assets/images/dashboard-2/user/3.png",
	"./dashboard-2/user/4.png": "./public/assets/images/dashboard-2/user/4.png",
	"./dashboard-2/user/5.png": "./public/assets/images/dashboard-2/user/5.png",
	"./dashboard-2/user/6.png": "./public/assets/images/dashboard-2/user/6.png",
	"./dashboard-2/user/7.png": "./public/assets/images/dashboard-2/user/7.png",
	"./dashboard-2/user/8.png": "./public/assets/images/dashboard-2/user/8.png",
	"./dashboard-2/user/9.png": "./public/assets/images/dashboard-2/user/9.png",
	"./dashboard-3/design-card.png": "./public/assets/images/dashboard-3/design-card.png",
	"./dashboard-3/sun.gif": "./public/assets/images/dashboard-3/sun.gif",
	"./dashboard-3/sun.png": "./public/assets/images/dashboard-3/sun.png",
	"./dashboard-3/user/1.png": "./public/assets/images/dashboard-3/user/1.png",
	"./dashboard-3/user/10.png": "./public/assets/images/dashboard-3/user/10.png",
	"./dashboard-3/user/11.png": "./public/assets/images/dashboard-3/user/11.png",
	"./dashboard-3/user/12.png": "./public/assets/images/dashboard-3/user/12.png",
	"./dashboard-3/user/13.png": "./public/assets/images/dashboard-3/user/13.png",
	"./dashboard-3/user/14.png": "./public/assets/images/dashboard-3/user/14.png",
	"./dashboard-3/user/15.png": "./public/assets/images/dashboard-3/user/15.png",
	"./dashboard-3/user/16.png": "./public/assets/images/dashboard-3/user/16.png",
	"./dashboard-3/user/17.png": "./public/assets/images/dashboard-3/user/17.png",
	"./dashboard-3/user/18.png": "./public/assets/images/dashboard-3/user/18.png",
	"./dashboard-3/user/19.png": "./public/assets/images/dashboard-3/user/19.png",
	"./dashboard-3/user/2.png": "./public/assets/images/dashboard-3/user/2.png",
	"./dashboard-3/user/3.png": "./public/assets/images/dashboard-3/user/3.png",
	"./dashboard-3/user/4.png": "./public/assets/images/dashboard-3/user/4.png",
	"./dashboard-3/user/5.png": "./public/assets/images/dashboard-3/user/5.png",
	"./dashboard-3/user/6.png": "./public/assets/images/dashboard-3/user/6.png",
	"./dashboard-3/user/7.png": "./public/assets/images/dashboard-3/user/7.png",
	"./dashboard-3/user/8.png": "./public/assets/images/dashboard-3/user/8.png",
	"./dashboard-3/user/9.png": "./public/assets/images/dashboard-3/user/9.png",
	"./dashboard-8/order-trash.gif": "./public/assets/images/dashboard-8/order-trash.gif",
	"./dashboard-8/payment-option/card.svg": "./public/assets/images/dashboard-8/payment-option/card.svg",
	"./dashboard-8/payment-option/cash.svg": "./public/assets/images/dashboard-8/payment-option/cash.svg",
	"./dashboard-8/payment-option/wallet.svg": "./public/assets/images/dashboard-8/payment-option/wallet.svg",
	"./dashboard-8/product-categories/drone.png": "./public/assets/images/dashboard-8/product-categories/drone.png",
	"./dashboard-8/product-categories/dvd.png": "./public/assets/images/dashboard-8/product-categories/dvd.png",
	"./dashboard-8/product-categories/headphone.png": "./public/assets/images/dashboard-8/product-categories/headphone.png",
	"./dashboard-8/product-categories/ipad.png": "./public/assets/images/dashboard-8/product-categories/ipad.png",
	"./dashboard-8/product-categories/keyboard.png": "./public/assets/images/dashboard-8/product-categories/keyboard.png",
	"./dashboard-8/product-categories/laptop.png": "./public/assets/images/dashboard-8/product-categories/laptop.png",
	"./dashboard-8/product-categories/mac-laptop.png": "./public/assets/images/dashboard-8/product-categories/mac-laptop.png",
	"./dashboard-8/product-categories/mouse.png": "./public/assets/images/dashboard-8/product-categories/mouse.png",
	"./dashboard-8/product-categories/phone.png": "./public/assets/images/dashboard-8/product-categories/phone.png",
	"./dashboard-8/product-categories/speaker.png": "./public/assets/images/dashboard-8/product-categories/speaker.png",
	"./dashboard-8/product-categories/watch-2.png": "./public/assets/images/dashboard-8/product-categories/watch-2.png",
	"./dashboard-8/product-categories/watch.png": "./public/assets/images/dashboard-8/product-categories/watch.png",
	"./dashboard-8/product-categories/wireless-headphone.png": "./public/assets/images/dashboard-8/product-categories/wireless-headphone.png",
	"./dashboard-8/profile-bg.png": "./public/assets/images/dashboard-8/profile-bg.png",
	"./dashboard-8/profile.png": "./public/assets/images/dashboard-8/profile.png",
	"./dashboard-8/shop-categories/camera.png": "./public/assets/images/dashboard-8/shop-categories/camera.png",
	"./dashboard-8/shop-categories/dron.png": "./public/assets/images/dashboard-8/shop-categories/dron.png",
	"./dashboard-8/shop-categories/headphone.png": "./public/assets/images/dashboard-8/shop-categories/headphone.png",
	"./dashboard-8/shop-categories/keyboard.png": "./public/assets/images/dashboard-8/shop-categories/keyboard.png",
	"./dashboard-8/shop-categories/laptop-bag.png": "./public/assets/images/dashboard-8/shop-categories/laptop-bag.png",
	"./dashboard-8/shop-categories/laptop.png": "./public/assets/images/dashboard-8/shop-categories/laptop.png",
	"./dashboard-8/shop-categories/mouse.png": "./public/assets/images/dashboard-8/shop-categories/mouse.png",
	"./dashboard-8/shop-categories/phone.png": "./public/assets/images/dashboard-8/shop-categories/phone.png",
	"./dashboard-8/shop-categories/watch.png": "./public/assets/images/dashboard-8/shop-categories/watch.png",
	"./dashboard/01.png": "./public/assets/images/dashboard/01.png",
	"./dashboard/02.png": "./public/assets/images/dashboard/02.png",
	"./dashboard/03.png": "./public/assets/images/dashboard/03.png",
	"./dashboard/04.jpg": "./public/assets/images/dashboard/04.jpg",
	"./dashboard/04.png": "./public/assets/images/dashboard/04.png",
	"./dashboard/05.jpg": "./public/assets/images/dashboard/05.jpg",
	"./dashboard/06.jpg": "./public/assets/images/dashboard/06.jpg",
	"./dashboard/07.jpg": "./public/assets/images/dashboard/07.jpg",
	"./dashboard/09.jpg": "./public/assets/images/dashboard/09.jpg",
	"./dashboard/09.png": "./public/assets/images/dashboard/09.png",
	"./dashboard/1.jpg": "./public/assets/images/dashboard/1.jpg",
	"./dashboard/10.jpg": "./public/assets/images/dashboard/10.jpg",
	"./dashboard/11.jpg": "./public/assets/images/dashboard/11.jpg",
	"./dashboard/12.jpg": "./public/assets/images/dashboard/12.jpg",
	"./dashboard/13.jpg": "./public/assets/images/dashboard/13.jpg",
	"./dashboard/14.jpg": "./public/assets/images/dashboard/14.jpg",
	"./dashboard/2.jpg": "./public/assets/images/dashboard/2.jpg",
	"./dashboard/2.png": "./public/assets/images/dashboard/2.png",
	"./dashboard/3.jpg": "./public/assets/images/dashboard/3.jpg",
	"./dashboard/3.png": "./public/assets/images/dashboard/3.png",
	"./dashboard/4.jpg": "./public/assets/images/dashboard/4.jpg",
	"./dashboard/4.png": "./public/assets/images/dashboard/4.png",
	"./dashboard/5.jpg": "./public/assets/images/dashboard/5.jpg",
	"./dashboard/avtar/10.jpg": "./public/assets/images/dashboard/avtar/10.jpg",
	"./dashboard/avtar/12.jpg": "./public/assets/images/dashboard/avtar/12.jpg",
	"./dashboard/avtar/13.jpg": "./public/assets/images/dashboard/avtar/13.jpg",
	"./dashboard/avtar/14.jpg": "./public/assets/images/dashboard/avtar/14.jpg",
	"./dashboard/avtar/15.jpg": "./public/assets/images/dashboard/avtar/15.jpg",
	"./dashboard/avtar/17.jpg": "./public/assets/images/dashboard/avtar/17.jpg",
	"./dashboard/avtar/18.jpg": "./public/assets/images/dashboard/avtar/18.jpg",
	"./dashboard/avtar/19.jpg": "./public/assets/images/dashboard/avtar/19.jpg",
	"./dashboard/avtar/2.jpg": "./public/assets/images/dashboard/avtar/2.jpg",
	"./dashboard/avtar/20.jpg": "./public/assets/images/dashboard/avtar/20.jpg",
	"./dashboard/avtar/21.jpg": "./public/assets/images/dashboard/avtar/21.jpg",
	"./dashboard/avtar/22.jpg": "./public/assets/images/dashboard/avtar/22.jpg",
	"./dashboard/avtar/23.jpg": "./public/assets/images/dashboard/avtar/23.jpg",
	"./dashboard/avtar/24.jpg": "./public/assets/images/dashboard/avtar/24.jpg",
	"./dashboard/avtar/8.jpg": "./public/assets/images/dashboard/avtar/8.jpg",
	"./dashboard/bg.png": "./public/assets/images/dashboard/bg.png",
	"./dashboard/books.gif": "./public/assets/images/dashboard/books.gif",
	"./dashboard/folder.png": "./public/assets/images/dashboard/folder.png",
	"./dashboard/massage.gif": "./public/assets/images/dashboard/massage.gif",
	"./dashboard/premium-courses.gif": "./public/assets/images/dashboard/premium-courses.gif",
	"./dashboard/premium-courses.png": "./public/assets/images/dashboard/premium-courses.png",
	"./dashboard/profile.png": "./public/assets/images/dashboard/profile.png",
	"./dashboard/user/01.png": "./public/assets/images/dashboard/user/01.png",
	"./dashboard/user/010.jpg": "./public/assets/images/dashboard/user/010.jpg",
	"./dashboard/user/011.jpg": "./public/assets/images/dashboard/user/011.jpg",
	"./dashboard/user/012.jpg": "./public/assets/images/dashboard/user/012.jpg",
	"./dashboard/user/02.png": "./public/assets/images/dashboard/user/02.png",
	"./dashboard/user/03.png": "./public/assets/images/dashboard/user/03.png",
	"./dashboard/user/04.png": "./public/assets/images/dashboard/user/04.png",
	"./dashboard/user/05.jpg": "./public/assets/images/dashboard/user/05.jpg",
	"./dashboard/user/06.jpg": "./public/assets/images/dashboard/user/06.jpg",
	"./dashboard/user/07.jpg": "./public/assets/images/dashboard/user/07.jpg",
	"./dashboard/user/08.jpg": "./public/assets/images/dashboard/user/08.jpg",
	"./dashboard/user/09.jpg": "./public/assets/images/dashboard/user/09.jpg",
	"./dashboard/user/1.png": "./public/assets/images/dashboard/user/1.png",
	"./dashboard/user/10.jpg": "./public/assets/images/dashboard/user/10.jpg",
	"./dashboard/user/11.jpg": "./public/assets/images/dashboard/user/11.jpg",
	"./dashboard/user/12.jpg": "./public/assets/images/dashboard/user/12.jpg",
	"./dashboard/user/13.jpg": "./public/assets/images/dashboard/user/13.jpg",
	"./dashboard/user/14.png": "./public/assets/images/dashboard/user/14.png",
	"./dashboard/user/15.png": "./public/assets/images/dashboard/user/15.png",
	"./dashboard/user/16.png": "./public/assets/images/dashboard/user/16.png",
	"./dashboard/user/17.png": "./public/assets/images/dashboard/user/17.png",
	"./dashboard/user/18.png": "./public/assets/images/dashboard/user/18.png",
	"./dashboard/user/19.png": "./public/assets/images/dashboard/user/19.png",
	"./dashboard/user/2.png": "./public/assets/images/dashboard/user/2.png",
	"./dashboard/user/20.png": "./public/assets/images/dashboard/user/20.png",
	"./dashboard/user/21.png": "./public/assets/images/dashboard/user/21.png",
	"./dashboard/user/3.png": "./public/assets/images/dashboard/user/3.png",
	"./dashboard/user/4.png": "./public/assets/images/dashboard/user/4.png",
	"./dashboard/user/5.jpg": "./public/assets/images/dashboard/user/5.jpg",
	"./dashboard/user/6.jpg": "./public/assets/images/dashboard/user/6.jpg",
	"./dashboard/user/7.jpg": "./public/assets/images/dashboard/user/7.jpg",
	"./dashboard/user/8.jpg": "./public/assets/images/dashboard/user/8.jpg",
	"./dashboard/user/9.jpg": "./public/assets/images/dashboard/user/9.jpg",
	"./dashboard/widget-bg.png": "./public/assets/images/dashboard/widget-bg.png",
	"./details_close.png": "./public/assets/images/details_close.png",
	"./details_open.png": "./public/assets/images/details_open.png",
	"./ecommerce/01.jpg": "./public/assets/images/ecommerce/01.jpg",
	"./ecommerce/02.jpg": "./public/assets/images/ecommerce/02.jpg",
	"./ecommerce/03.jpg": "./public/assets/images/ecommerce/03.jpg",
	"./ecommerce/04.jpg": "./public/assets/images/ecommerce/04.jpg",
	"./ecommerce/05.jpg": "./public/assets/images/ecommerce/05.jpg",
	"./ecommerce/06.jpg": "./public/assets/images/ecommerce/06.jpg",
	"./ecommerce/07.jpg": "./public/assets/images/ecommerce/07.jpg",
	"./ecommerce/08.jpg": "./public/assets/images/ecommerce/08.jpg",
	"./ecommerce/09.jpg": "./public/assets/images/ecommerce/09.jpg",
	"./ecommerce/10.jpg": "./public/assets/images/ecommerce/10.jpg",
	"./ecommerce/11.jpg": "./public/assets/images/ecommerce/11.jpg",
	"./ecommerce/12.jpg": "./public/assets/images/ecommerce/12.jpg",
	"./ecommerce/13.jpg": "./public/assets/images/ecommerce/13.jpg",
	"./ecommerce/14.jpg": "./public/assets/images/ecommerce/14.jpg",
	"./ecommerce/15.jpg": "./public/assets/images/ecommerce/15.jpg",
	"./ecommerce/16.jpg": "./public/assets/images/ecommerce/16.jpg",
	"./ecommerce/banner.jpg": "./public/assets/images/ecommerce/banner.jpg",
	"./ecommerce/card.png": "./public/assets/images/ecommerce/card.png",
	"./ecommerce/mastercard.png": "./public/assets/images/ecommerce/mastercard.png",
	"./ecommerce/paypal.png": "./public/assets/images/ecommerce/paypal.png",
	"./ecommerce/product-table-1.png": "./public/assets/images/ecommerce/product-table-1.png",
	"./ecommerce/product-table-2.png": "./public/assets/images/ecommerce/product-table-2.png",
	"./ecommerce/product-table-3.png": "./public/assets/images/ecommerce/product-table-3.png",
	"./ecommerce/product-table-4.png": "./public/assets/images/ecommerce/product-table-4.png",
	"./ecommerce/product-table-5.png": "./public/assets/images/ecommerce/product-table-5.png",
	"./ecommerce/product-table-6.png": "./public/assets/images/ecommerce/product-table-6.png",
	"./ecommerce/product-table-7.png": "./public/assets/images/ecommerce/product-table-7.png",
	"./ecommerce/visa.png": "./public/assets/images/ecommerce/visa.png",
	"./email-template/1.jpg": "./public/assets/images/email-template/1.jpg",
	"./email-template/1.png": "./public/assets/images/email-template/1.png",
	"./email-template/10.jpg": "./public/assets/images/email-template/10.jpg",
	"./email-template/11.jpg": "./public/assets/images/email-template/11.jpg",
	"./email-template/12.jpg": "./public/assets/images/email-template/12.jpg",
	"./email-template/2.png": "./public/assets/images/email-template/2.png",
	"./email-template/3.png": "./public/assets/images/email-template/3.png",
	"./email-template/4.png": "./public/assets/images/email-template/4.png",
	"./email-template/5.png": "./public/assets/images/email-template/5.png",
	"./email-template/6.png": "./public/assets/images/email-template/6.png",
	"./email-template/7.jpg": "./public/assets/images/email-template/7.jpg",
	"./email-template/7.png": "./public/assets/images/email-template/7.png",
	"./email-template/8.jpg": "./public/assets/images/email-template/8.jpg",
	"./email-template/8.png": "./public/assets/images/email-template/8.png",
	"./email-template/banner-2.jpg": "./public/assets/images/email-template/banner-2.jpg",
	"./email-template/banner.jpg": "./public/assets/images/email-template/banner.jpg",
	"./email-template/cosmetic.jpg": "./public/assets/images/email-template/cosmetic.jpg",
	"./email-template/delivery-2.png": "./public/assets/images/email-template/delivery-2.png",
	"./email-template/delivery.png": "./public/assets/images/email-template/delivery.png",
	"./email-template/facebook.png": "./public/assets/images/email-template/facebook.png",
	"./email-template/gplus.png": "./public/assets/images/email-template/gplus.png",
	"./email-template/invoice-1/1.png": "./public/assets/images/email-template/invoice-1/1.png",
	"./email-template/invoice-1/sign.png": "./public/assets/images/email-template/invoice-1/sign.png",
	"./email-template/invoice-3/bg-0.png": "./public/assets/images/email-template/invoice-3/bg-0.png",
	"./email-template/invoice-3/bg.jpg": "./public/assets/images/email-template/invoice-3/bg.jpg",
	"./email-template/invoice-3/bg.png": "./public/assets/images/email-template/invoice-3/bg.png",
	"./email-template/invoice-3/sign.png": "./public/assets/images/email-template/invoice-3/sign.png",
	"./email-template/linkedin.png": "./public/assets/images/email-template/linkedin.png",
	"./email-template/order-success.png": "./public/assets/images/email-template/order-success.png",
	"./email-template/pdfs.png": "./public/assets/images/email-template/pdfs.png",
	"./email-template/pinterest.png": "./public/assets/images/email-template/pinterest.png",
	"./email-template/slider.jpg": "./public/assets/images/email-template/slider.jpg",
	"./email-template/space.jpg": "./public/assets/images/email-template/space.jpg",
	"./email-template/success.png": "./public/assets/images/email-template/success.png",
	"./email-template/twitter.png": "./public/assets/images/email-template/twitter.png",
	"./email-template/youtube.png": "./public/assets/images/email-template/youtube.png",
	"./email/1.jpg": "./public/assets/images/email/1.jpg",
	"./email/2.jpg": "./public/assets/images/email/2.jpg",
	"./email/3.jpg": "./public/assets/images/email/3.jpg",
	"./faq/1.jpg": "./public/assets/images/faq/1.jpg",
	"./faq/2.jpg": "./public/assets/images/faq/2.jpg",
	"./faq/3.jpg": "./public/assets/images/faq/3.jpg",
	"./faq/4.jpg": "./public/assets/images/faq/4.jpg",
	"./faq/learning-1.png": "./public/assets/images/faq/learning-1.png",
	"./favicon.png": "./public/assets/images/favicon.png",
	"./forms/Bank-of-Baroda.png": "./public/assets/images/forms/Bank-of-Baroda.png",
	"./forms/MasterCard.png": "./public/assets/images/forms/MasterCard.png",
	"./forms/SCB.png": "./public/assets/images/forms/SCB.png",
	"./forms/authenticate.png": "./public/assets/images/forms/authenticate.png",
	"./forms/axis.png": "./public/assets/images/forms/axis.png",
	"./forms/credit-card.png": "./public/assets/images/forms/credit-card.png",
	"./forms/delivery.png": "./public/assets/images/forms/delivery.png",
	"./forms/email.png": "./public/assets/images/forms/email.png",
	"./forms/flags.png": "./public/assets/images/forms/flags.png",
	"./forms/hdfc.png": "./public/assets/images/forms/hdfc.png",
	"./forms/idbi.png": "./public/assets/images/forms/idbi.png",
	"./forms/qr-code.png": "./public/assets/images/forms/qr-code.png",
	"./forms/qr-scan.png": "./public/assets/images/forms/qr-scan.png",
	"./forms/rbl.png": "./public/assets/images/forms/rbl.png",
	"./forms/us-bank.png": "./public/assets/images/forms/us-bank.png",
	"./forms/user.png": "./public/assets/images/forms/user.png",
	"./gif/danger.gif": "./public/assets/images/gif/danger.gif",
	"./gif/dashboard-8/successful.gif": "./public/assets/images/gif/dashboard-8/successful.gif",
	"./gif/facebook.gif": "./public/assets/images/gif/facebook.gif",
	"./gif/instagram.gif": "./public/assets/images/gif/instagram.gif",
	"./gif/logout.gif": "./public/assets/images/gif/logout.gif",
	"./gif/online-shopping.gif": "./public/assets/images/gif/online-shopping.gif",
	"./gif/successful.gif": "./public/assets/images/gif/successful.gif",
	"./gif/whatapp.gif": "./public/assets/images/gif/whatapp.gif",
	"./giftools.gif": "./public/assets/images/giftools.gif",
	"./job-search/1.jpg": "./public/assets/images/job-search/1.jpg",
	"./job-search/2.jpg": "./public/assets/images/job-search/2.jpg",
	"./job-search/3.jpg": "./public/assets/images/job-search/3.jpg",
	"./job-search/4.jpg": "./public/assets/images/job-search/4.jpg",
	"./job-search/5.jpg": "./public/assets/images/job-search/5.jpg",
	"./job-search/6.jpg": "./public/assets/images/job-search/6.jpg",
	"./js-grid.png": "./public/assets/images/js-grid.png",
	"./knowledgebase/bg_1.jpg": "./public/assets/images/knowledgebase/bg_1.jpg",
	"./landing/application/1.jpg": "./public/assets/images/landing/application/1.jpg",
	"./landing/application/10.jpg": "./public/assets/images/landing/application/10.jpg",
	"./landing/application/11.jpg": "./public/assets/images/landing/application/11.jpg",
	"./landing/application/12.jpg": "./public/assets/images/landing/application/12.jpg",
	"./landing/application/2.jpg": "./public/assets/images/landing/application/2.jpg",
	"./landing/application/3.jpg": "./public/assets/images/landing/application/3.jpg",
	"./landing/application/4.jpg": "./public/assets/images/landing/application/4.jpg",
	"./landing/application/5.jpg": "./public/assets/images/landing/application/5.jpg",
	"./landing/application/6.jpg": "./public/assets/images/landing/application/6.jpg",
	"./landing/application/7.jpg": "./public/assets/images/landing/application/7.jpg",
	"./landing/application/8.jpg": "./public/assets/images/landing/application/8.jpg",
	"./landing/application/9.jpg": "./public/assets/images/landing/application/9.jpg",
	"./landing/demo/1.jpg": "./public/assets/images/landing/demo/1.jpg",
	"./landing/demo/2.jpg": "./public/assets/images/landing/demo/2.jpg",
	"./landing/feature-icon/1.svg": "./public/assets/images/landing/feature-icon/1.svg",
	"./landing/feature-icon/2.svg": "./public/assets/images/landing/feature-icon/2.svg",
	"./landing/feature-icon/3.svg": "./public/assets/images/landing/feature-icon/3.svg",
	"./landing/feature-icon/4.svg": "./public/assets/images/landing/feature-icon/4.svg",
	"./landing/feature-icon/5.svg": "./public/assets/images/landing/feature-icon/5.svg",
	"./landing/feature-icon/6.svg": "./public/assets/images/landing/feature-icon/6.svg",
	"./landing/feature-icon/7.svg": "./public/assets/images/landing/feature-icon/7.svg",
	"./landing/feature-icon/8.svg": "./public/assets/images/landing/feature-icon/8.svg",
	"./landing/footer.png": "./public/assets/images/landing/footer.png",
	"./landing/icon/1.svg": "./public/assets/images/landing/icon/1.svg",
	"./landing/icon/10.svg": "./public/assets/images/landing/icon/10.svg",
	"./landing/icon/11.svg": "./public/assets/images/landing/icon/11.svg",
	"./landing/icon/12.svg": "./public/assets/images/landing/icon/12.svg",
	"./landing/icon/13.svg": "./public/assets/images/landing/icon/13.svg",
	"./landing/icon/14.svg": "./public/assets/images/landing/icon/14.svg",
	"./landing/icon/15.svg": "./public/assets/images/landing/icon/15.svg",
	"./landing/icon/16.svg": "./public/assets/images/landing/icon/16.svg",
	"./landing/icon/17.svg": "./public/assets/images/landing/icon/17.svg",
	"./landing/icon/18.svg": "./public/assets/images/landing/icon/18.svg",
	"./landing/icon/19.svg": "./public/assets/images/landing/icon/19.svg",
	"./landing/icon/2.svg": "./public/assets/images/landing/icon/2.svg",
	"./landing/icon/20.svg": "./public/assets/images/landing/icon/20.svg",
	"./landing/icon/21.svg": "./public/assets/images/landing/icon/21.svg",
	"./landing/icon/22.svg": "./public/assets/images/landing/icon/22.svg",
	"./landing/icon/23.svg": "./public/assets/images/landing/icon/23.svg",
	"./landing/icon/24.svg": "./public/assets/images/landing/icon/24.svg",
	"./landing/icon/25.svg": "./public/assets/images/landing/icon/25.svg",
	"./landing/icon/26.svg": "./public/assets/images/landing/icon/26.svg",
	"./landing/icon/27.svg": "./public/assets/images/landing/icon/27.svg",
	"./landing/icon/28.svg": "./public/assets/images/landing/icon/28.svg",
	"./landing/icon/29.svg": "./public/assets/images/landing/icon/29.svg",
	"./landing/icon/3.svg": "./public/assets/images/landing/icon/3.svg",
	"./landing/icon/30.svg": "./public/assets/images/landing/icon/30.svg",
	"./landing/icon/4.svg": "./public/assets/images/landing/icon/4.svg",
	"./landing/icon/5.svg": "./public/assets/images/landing/icon/5.svg",
	"./landing/icon/6.svg": "./public/assets/images/landing/icon/6.svg",
	"./landing/icon/7.svg": "./public/assets/images/landing/icon/7.svg",
	"./landing/icon/8.svg": "./public/assets/images/landing/icon/8.svg",
	"./landing/icon/9.svg": "./public/assets/images/landing/icon/9.svg",
	"./landing/icon/angular/1.png": "./public/assets/images/landing/icon/angular/1.png",
	"./landing/icon/angular/10.png": "./public/assets/images/landing/icon/angular/10.png",
	"./landing/icon/angular/11.png": "./public/assets/images/landing/icon/angular/11.png",
	"./landing/icon/angular/12.png": "./public/assets/images/landing/icon/angular/12.png",
	"./landing/icon/angular/13.png": "./public/assets/images/landing/icon/angular/13.png",
	"./landing/icon/angular/14.png": "./public/assets/images/landing/icon/angular/14.png",
	"./landing/icon/angular/2.png": "./public/assets/images/landing/icon/angular/2.png",
	"./landing/icon/angular/3.png": "./public/assets/images/landing/icon/angular/3.png",
	"./landing/icon/angular/4.png": "./public/assets/images/landing/icon/angular/4.png",
	"./landing/icon/angular/5.png": "./public/assets/images/landing/icon/angular/5.png",
	"./landing/icon/angular/6.png": "./public/assets/images/landing/icon/angular/6.png",
	"./landing/icon/angular/7.png": "./public/assets/images/landing/icon/angular/7.png",
	"./landing/icon/angular/8.png": "./public/assets/images/landing/icon/angular/8.png",
	"./landing/icon/angular/9.png": "./public/assets/images/landing/icon/angular/9.png",
	"./landing/icon/angular/angular.png": "./public/assets/images/landing/icon/angular/angular.png",
	"./landing/icon/angular/angular.svg": "./public/assets/images/landing/icon/angular/angular.svg",
	"./landing/icon/html/apps.png": "./public/assets/images/landing/icon/html/apps.png",
	"./landing/icon/html/bootstrap.png": "./public/assets/images/landing/icon/html/bootstrap.png",
	"./landing/icon/html/builders.png": "./public/assets/images/landing/icon/html/builders.png",
	"./landing/icon/html/charts.png": "./public/assets/images/landing/icon/html/charts.png",
	"./landing/icon/html/css.png": "./public/assets/images/landing/icon/html/css.png",
	"./landing/icon/html/forms.png": "./public/assets/images/landing/icon/html/forms.png",
	"./landing/icon/html/gulp.png": "./public/assets/images/landing/icon/html/gulp.png",
	"./landing/icon/html/html.png": "./public/assets/images/landing/icon/html/html.png",
	"./landing/icon/html/iconset.png": "./public/assets/images/landing/icon/html/iconset.png",
	"./landing/icon/html/kit.png": "./public/assets/images/landing/icon/html/kit.png",
	"./landing/icon/html/layout.png": "./public/assets/images/landing/icon/html/layout.png",
	"./landing/icon/html/npm.png": "./public/assets/images/landing/icon/html/npm.png",
	"./landing/icon/html/pug.png": "./public/assets/images/landing/icon/html/pug.png",
	"./landing/icon/html/sass.png": "./public/assets/images/landing/icon/html/sass.png",
	"./landing/icon/html/table.png": "./public/assets/images/landing/icon/html/table.png",
	"./landing/icon/html/uikits.png": "./public/assets/images/landing/icon/html/uikits.png",
	"./landing/icon/laravel/apex.png": "./public/assets/images/landing/icon/laravel/apex.png",
	"./landing/icon/laravel/apps.png": "./public/assets/images/landing/icon/laravel/apps.png",
	"./landing/icon/laravel/blade.png": "./public/assets/images/landing/icon/laravel/blade.png",
	"./landing/icon/laravel/bootstrap.png": "./public/assets/images/landing/icon/laravel/bootstrap.png",
	"./landing/icon/laravel/chartist.png": "./public/assets/images/landing/icon/laravel/chartist.png",
	"./landing/icon/laravel/chartjs.png": "./public/assets/images/landing/icon/laravel/chartjs.png",
	"./landing/icon/laravel/forms.png": "./public/assets/images/landing/icon/laravel/forms.png",
	"./landing/icon/laravel/gallery.png": "./public/assets/images/landing/icon/laravel/gallery.png",
	"./landing/icon/laravel/iconset.png": "./public/assets/images/landing/icon/laravel/iconset.png",
	"./landing/icon/laravel/laravel.png": "./public/assets/images/landing/icon/laravel/laravel.png",
	"./landing/icon/laravel/laravel2.png": "./public/assets/images/landing/icon/laravel/laravel2.png",
	"./landing/icon/laravel/layout.png": "./public/assets/images/landing/icon/laravel/layout.png",
	"./landing/icon/laravel/uikits.png": "./public/assets/images/landing/icon/laravel/uikits.png",
	"./landing/icon/react/animation.png": "./public/assets/images/landing/icon/react/animation.png",
	"./landing/icon/react/apex.png": "./public/assets/images/landing/icon/react/apex.png",
	"./landing/icon/react/application.png": "./public/assets/images/landing/icon/react/application.png",
	"./landing/icon/react/bootstrap.png": "./public/assets/images/landing/icon/react/bootstrap.png",
	"./landing/icon/react/chart.png": "./public/assets/images/landing/icon/react/chart.png",
	"./landing/icon/react/chartist.png": "./public/assets/images/landing/icon/react/chartist.png",
	"./landing/icon/react/chat.png": "./public/assets/images/landing/icon/react/chat.png",
	"./landing/icon/react/gallery.png": "./public/assets/images/landing/icon/react/gallery.png",
	"./landing/icon/react/hook.png": "./public/assets/images/landing/icon/react/hook.png",
	"./landing/icon/react/iconset.png": "./public/assets/images/landing/icon/react/iconset.png",
	"./landing/icon/react/map.png": "./public/assets/images/landing/icon/react/map.png",
	"./landing/icon/react/noquery.png": "./public/assets/images/landing/icon/react/noquery.png",
	"./landing/icon/react/props_state.png": "./public/assets/images/landing/icon/react/props_state.png",
	"./landing/icon/react/react.png": "./public/assets/images/landing/icon/react/react.png",
	"./landing/icon/react/react1.png": "./public/assets/images/landing/icon/react/react1.png",
	"./landing/icon/react/reactrouter.png": "./public/assets/images/landing/icon/react/reactrouter.png",
	"./landing/icon/react/reactstrap.png": "./public/assets/images/landing/icon/react/reactstrap.png",
	"./landing/icon/react/redux.png": "./public/assets/images/landing/icon/react/redux.png",
	"./landing/icon/react/table.png": "./public/assets/images/landing/icon/react/table.png",
	"./landing/icon/vue/animation.png": "./public/assets/images/landing/icon/vue/animation.png",
	"./landing/icon/vue/chart.png": "./public/assets/images/landing/icon/vue/chart.png",
	"./landing/icon/vue/nojquery.png": "./public/assets/images/landing/icon/vue/nojquery.png",
	"./landing/icon/vue/rangeslider.png": "./public/assets/images/landing/icon/vue/rangeslider.png",
	"./landing/icon/vue/rtlsupport.png": "./public/assets/images/landing/icon/vue/rtlsupport.png",
	"./landing/icon/vue/vue.png": "./public/assets/images/landing/icon/vue/vue.png",
	"./landing/icon/vue/vuecli.png": "./public/assets/images/landing/icon/vue/vuecli.png",
	"./landing/icon/vue/vuemasonary.png": "./public/assets/images/landing/icon/vue/vuemasonary.png",
	"./landing/icon/vue/vuerouter.png": "./public/assets/images/landing/icon/vue/vuerouter.png",
	"./landing/icon/vue/vueswiper.png": "./public/assets/images/landing/icon/vue/vueswiper.png",
	"./landing/icon/vue/vuex.png": "./public/assets/images/landing/icon/vue/vuex.png",
	"./landing/landing-home/01.jpg": "./public/assets/images/landing/landing-home/01.jpg",
	"./landing/landing-home/02.jpg": "./public/assets/images/landing/landing-home/02.jpg",
	"./landing/landing-home/03.jpg": "./public/assets/images/landing/landing-home/03.jpg",
	"./landing/landing-home/04.jpg": "./public/assets/images/landing/landing-home/04.jpg",
	"./landing/landing-home/05.jpg": "./public/assets/images/landing/landing-home/05.jpg",
	"./landing/landing-home/dashboard.png": "./public/assets/images/landing/landing-home/dashboard.png",
	"./landing/landing-home/home-bg.jpg": "./public/assets/images/landing/landing-home/home-bg.jpg",
	"./landing/landing-home/home-bg.png": "./public/assets/images/landing/landing-home/home-bg.png",
	"./landing/landing-home/vector/1.png": "./public/assets/images/landing/landing-home/vector/1.png",
	"./landing/landing-home/vector/2.png": "./public/assets/images/landing/landing-home/vector/2.png",
	"./landing/landing-home/vector/3.png": "./public/assets/images/landing/landing-home/vector/3.png",
	"./landing/landing-home/vector/4.png": "./public/assets/images/landing/landing-home/vector/4.png",
	"./landing/landing-home/vector/5.png": "./public/assets/images/landing/landing-home/vector/5.png",
	"./landing/landing-home/vector/6.png": "./public/assets/images/landing/landing-home/vector/6.png",
	"./landing/landing-home/vector/7.png": "./public/assets/images/landing/landing-home/vector/7.png",
	"./landing/landing-home/vector/line.png": "./public/assets/images/landing/landing-home/vector/line.png",
	"./landing/landing-home/vector/rocket.png": "./public/assets/images/landing/landing-home/vector/rocket.png",
	"./landing/layout/1.jpg": "./public/assets/images/landing/layout/1.jpg",
	"./landing/layout/2.jpg": "./public/assets/images/landing/layout/2.jpg",
	"./landing/layout/3.jpg": "./public/assets/images/landing/layout/3.jpg",
	"./landing/layout/4.jpg": "./public/assets/images/landing/layout/4.jpg",
	"./landing/layout/5.jpg": "./public/assets/images/landing/layout/5.jpg",
	"./landing/layout/6.jpg": "./public/assets/images/landing/layout/6.jpg",
	"./landing/layout/7.jpg": "./public/assets/images/landing/layout/7.jpg",
	"./landing/layout/8.jpg": "./public/assets/images/landing/layout/8.jpg",
	"./landing/layout/9.jpg": "./public/assets/images/landing/layout/9.jpg",
	"./landing/premium.png": "./public/assets/images/landing/premium.png",
	"./landing/responsive-card/responsive-card.jpg": "./public/assets/images/landing/responsive-card/responsive-card.jpg",
	"./lightgallry/01.jpg": "./public/assets/images/lightgallry/01.jpg",
	"./lightgallry/010.jpg": "./public/assets/images/lightgallry/010.jpg",
	"./lightgallry/011.jpg": "./public/assets/images/lightgallry/011.jpg",
	"./lightgallry/012.jpg": "./public/assets/images/lightgallry/012.jpg",
	"./lightgallry/013.jpg": "./public/assets/images/lightgallry/013.jpg",
	"./lightgallry/014.jpg": "./public/assets/images/lightgallry/014.jpg",
	"./lightgallry/015.jpg": "./public/assets/images/lightgallry/015.jpg",
	"./lightgallry/016.jpg": "./public/assets/images/lightgallry/016.jpg",
	"./lightgallry/02.jpg": "./public/assets/images/lightgallry/02.jpg",
	"./lightgallry/03.jpg": "./public/assets/images/lightgallry/03.jpg",
	"./lightgallry/04.jpg": "./public/assets/images/lightgallry/04.jpg",
	"./lightgallry/05.jpg": "./public/assets/images/lightgallry/05.jpg",
	"./lightgallry/06.jpg": "./public/assets/images/lightgallry/06.jpg",
	"./lightgallry/07.jpg": "./public/assets/images/lightgallry/07.jpg",
	"./lightgallry/08.jpg": "./public/assets/images/lightgallry/08.jpg",
	"./lightgallry/09.jpg": "./public/assets/images/lightgallry/09.jpg",
	"./lightgallry/default-skin.png": "./public/assets/images/lightgallry/default-skin.png",
	"./lightgallry/default-skin.svg": "./public/assets/images/lightgallry/default-skin.svg",
	"./login/1.jpg": "./public/assets/images/login/1.jpg",
	"./login/2.jpg": "./public/assets/images/login/2.jpg",
	"./login/3.jpg": "./public/assets/images/login/3.jpg",
	"./login/icon.png": "./public/assets/images/login/icon.png",
	"./login/login_bg.jpg": "./public/assets/images/login/login_bg.jpg",
	"./logo/landing-logo.png": "./public/assets/images/logo/landing-logo.png",
	"./logo/logo-ananatra-dark.png": "./public/assets/images/logo/logo-ananatra-dark.png",
	"./logo/logo-ananatra.png": "./public/assets/images/logo/logo-ananatra.png",
	"./logo/logo-icon.png": "./public/assets/images/logo/logo-icon.png",
	"./logo/logo.png": "./public/assets/images/logo/logo.png",
	"./logo/logo_dark.png": "./public/assets/images/logo/logo_dark.png",
	"./marker-icon-2x.png": "./public/assets/images/marker-icon-2x.png",
	"./marker-icon.png": "./public/assets/images/marker-icon.png",
	"./marker-shadow.png": "./public/assets/images/marker-shadow.png",
	"./masonry/1.jpg": "./public/assets/images/masonry/1.jpg",
	"./masonry/10.jpg": "./public/assets/images/masonry/10.jpg",
	"./masonry/11.jpg": "./public/assets/images/masonry/11.jpg",
	"./masonry/12.jpg": "./public/assets/images/masonry/12.jpg",
	"./masonry/13.jpg": "./public/assets/images/masonry/13.jpg",
	"./masonry/14.jpg": "./public/assets/images/masonry/14.jpg",
	"./masonry/15.jpg": "./public/assets/images/masonry/15.jpg",
	"./masonry/2.jpg": "./public/assets/images/masonry/2.jpg",
	"./masonry/3.jpg": "./public/assets/images/masonry/3.jpg",
	"./masonry/4.jpg": "./public/assets/images/masonry/4.jpg",
	"./masonry/5.jpg": "./public/assets/images/masonry/5.jpg",
	"./masonry/6.jpg": "./public/assets/images/masonry/6.jpg",
	"./masonry/7.jpg": "./public/assets/images/masonry/7.jpg",
	"./masonry/8.jpg": "./public/assets/images/masonry/8.jpg",
	"./masonry/9.jpg": "./public/assets/images/masonry/9.jpg",
	"./notification/1.jpg": "./public/assets/images/notification/1.jpg",
	"./notification/2.jpg": "./public/assets/images/notification/2.jpg",
	"./other-images/bg-profile.png": "./public/assets/images/other-images/bg-profile.png",
	"./other-images/boxbg.jpg": "./public/assets/images/other-images/boxbg.jpg",
	"./other-images/calender-bg.png": "./public/assets/images/other-images/calender-bg.png",
	"./other-images/calender-widget.jpg": "./public/assets/images/other-images/calender-widget.jpg",
	"./other-images/caller.jpg": "./public/assets/images/other-images/caller.jpg",
	"./other-images/cart-img.jpg": "./public/assets/images/other-images/cart-img.jpg",
	"./other-images/clock-face.png": "./public/assets/images/other-images/clock-face.png",
	"./other-images/coming-soon-bg.jpg": "./public/assets/images/other-images/coming-soon-bg.jpg",
	"./other-images/header-bg.svg": "./public/assets/images/other-images/header-bg.svg",
	"./other-images/img-cropper.jpg": "./public/assets/images/other-images/img-cropper.jpg",
	"./other-images/logo-login.png": "./public/assets/images/other-images/logo-login.png",
	"./other-images/maintenance-bg.jpg": "./public/assets/images/other-images/maintenance-bg.jpg",
	"./other-images/mobile-clock-wallpaper.jpg": "./public/assets/images/other-images/mobile-clock-wallpaper.jpg",
	"./other-images/mountain.jpg": "./public/assets/images/other-images/mountain.jpg",
	"./other-images/order-trash.gif": "./public/assets/images/other-images/order-trash.gif",
	"./other-images/paypal.png": "./public/assets/images/other-images/paypal.png",
	"./other-images/profile-bg.png": "./public/assets/images/other-images/profile-bg.png",
	"./other-images/profile-style-img.png": "./public/assets/images/other-images/profile-style-img.png",
	"./other-images/profile-style-img3.png": "./public/assets/images/other-images/profile-style-img3.png",
	"./other-images/receiver-img.jpg": "./public/assets/images/other-images/receiver-img.jpg",
	"./other-images/sad.gif": "./public/assets/images/other-images/sad.gif",
	"./other-images/sad.png": "./public/assets/images/other-images/sad.png",
	"./other-images/sea.jpg": "./public/assets/images/other-images/sea.jpg",
	"./other-images/sidebar-bg.jpg": "./public/assets/images/other-images/sidebar-bg.jpg",
	"./other-images/user-profile.png": "./public/assets/images/other-images/user-profile.png",
	"./other-images/wallpaper.jpg": "./public/assets/images/other-images/wallpaper.jpg",
	"./product/1.png": "./public/assets/images/product/1.png",
	"./product/10.png": "./public/assets/images/product/10.png",
	"./product/11.png": "./public/assets/images/product/11.png",
	"./product/12.png": "./public/assets/images/product/12.png",
	"./product/13.png": "./public/assets/images/product/13.png",
	"./product/14.png": "./public/assets/images/product/14.png",
	"./product/15.png": "./public/assets/images/product/15.png",
	"./product/16.png": "./public/assets/images/product/16.png",
	"./product/17.png": "./public/assets/images/product/17.png",
	"./product/18.png": "./public/assets/images/product/18.png",
	"./product/19.png": "./public/assets/images/product/19.png",
	"./product/2.png": "./public/assets/images/product/2.png",
	"./product/20.png": "./public/assets/images/product/20.png",
	"./product/21.png": "./public/assets/images/product/21.png",
	"./product/22.png": "./public/assets/images/product/22.png",
	"./product/23.png": "./public/assets/images/product/23.png",
	"./product/3.png": "./public/assets/images/product/3.png",
	"./product/4.png": "./public/assets/images/product/4.png",
	"./product/5.png": "./public/assets/images/product/5.png",
	"./product/6.png": "./public/assets/images/product/6.png",
	"./product/7.png": "./public/assets/images/product/7.png",
	"./product/9.png": "./public/assets/images/product/9.png",
	"./product/category/1.png": "./public/assets/images/product/category/1.png",
	"./product/category/2.png": "./public/assets/images/product/category/2.png",
	"./product/category/3.png": "./public/assets/images/product/category/3.png",
	"./product/category/4.png": "./public/assets/images/product/category/4.png",
	"./product/category/5.png": "./public/assets/images/product/category/5.png",
	"./product/category/purse.png": "./public/assets/images/product/category/purse.png",
	"./product/category/shoes.png": "./public/assets/images/product/category/shoes.png",
	"./product/category/toy.png": "./public/assets/images/product/category/toy.png",
	"./scrollbar/fashion1.jpg": "./public/assets/images/scrollbar/fashion1.jpg",
	"./scrollbar/fashion2.jpg": "./public/assets/images/scrollbar/fashion2.jpg",
	"./scrollbar/fashion3.jpg": "./public/assets/images/scrollbar/fashion3.jpg",
	"./scrollbar/fashion4.jpg": "./public/assets/images/scrollbar/fashion4.jpg",
	"./scrollbar/fashion5.jpg": "./public/assets/images/scrollbar/fashion5.jpg",
	"./scrollbar/fashion6.jpg": "./public/assets/images/scrollbar/fashion6.jpg",
	"./slider/1.jpg": "./public/assets/images/slider/1.jpg",
	"./slider/10.jpg": "./public/assets/images/slider/10.jpg",
	"./slider/11.jpg": "./public/assets/images/slider/11.jpg",
	"./slider/2.jpg": "./public/assets/images/slider/2.jpg",
	"./slider/3.jpg": "./public/assets/images/slider/3.jpg",
	"./slider/4.jpg": "./public/assets/images/slider/4.jpg",
	"./slider/5.jpg": "./public/assets/images/slider/5.jpg",
	"./slider/6.jpg": "./public/assets/images/slider/6.jpg",
	"./slider/7.jpg": "./public/assets/images/slider/7.jpg",
	"./slider/8.jpg": "./public/assets/images/slider/8.jpg",
	"./slider/9.jpg": "./public/assets/images/slider/9.jpg",
	"./smiley.png": "./public/assets/images/smiley.png",
	"./social-app/post-1.png": "./public/assets/images/social-app/post-1.png",
	"./social-app/post-2.png": "./public/assets/images/social-app/post-2.png",
	"./social-app/post-3.png": "./public/assets/images/social-app/post-3.png",
	"./social-app/post-4.png": "./public/assets/images/social-app/post-4.png",
	"./social-app/post-5.png": "./public/assets/images/social-app/post-5.png",
	"./social-app/post-6.png": "./public/assets/images/social-app/post-6.png",
	"./social-app/post-7.png": "./public/assets/images/social-app/post-7.png",
	"./social-app/post-8.png": "./public/assets/images/social-app/post-8.png",
	"./social-app/post-9.png": "./public/assets/images/social-app/post-9.png",
	"./social-app/social-image.png": "./public/assets/images/social-app/social-image.png",
	"./social-app/timeline-1.png": "./public/assets/images/social-app/timeline-1.png",
	"./social-app/timeline-2.png": "./public/assets/images/social-app/timeline-2.png",
	"./social-app/timeline-3.png": "./public/assets/images/social-app/timeline-3.png",
	"./social-app/timeline-4.png": "./public/assets/images/social-app/timeline-4.png",
	"./sort_asc.png": "./public/assets/images/sort_asc.png",
	"./sort_asc_disabled.png": "./public/assets/images/sort_asc_disabled.png",
	"./sort_both.png": "./public/assets/images/sort_both.png",
	"./sort_desc.png": "./public/assets/images/sort_desc.png",
	"./sort_desc_disabled.png": "./public/assets/images/sort_desc_disabled.png",
	"./start-conversion.jpg": "./public/assets/images/start-conversion.jpg",
	"./switch/1.jpg": "./public/assets/images/switch/1.jpg",
	"./switch/2.jpg": "./public/assets/images/switch/2.jpg",
	"./switch/3.jpg": "./public/assets/images/switch/3.jpg",
	"./switch/4.jpg": "./public/assets/images/switch/4.jpg",
	"./switch/5.jpg": "./public/assets/images/switch/5.jpg",
	"./switch/6.jpg": "./public/assets/images/switch/6.jpg",
	"./switch/7.jpg": "./public/assets/images/switch/7.jpg",
	"./switch/8.jpg": "./public/assets/images/switch/8.jpg",
	"./switch/square-gray.png": "./public/assets/images/switch/square-gray.png",
	"./switch/square.svg": "./public/assets/images/switch/square.svg",
	"./tree/32px.png": "./public/assets/images/tree/32px.png",
	"./tree/40px.png": "./public/assets/images/tree/40px.png",
	"./tree/throbber.gif": "./public/assets/images/tree/throbber.gif",
	"./upload-images.png": "./public/assets/images/upload-images.png",
	"./user-card/5.jpg": "./public/assets/images/user-card/5.jpg",
	"./user/1.jpg": "./public/assets/images/user/1.jpg",
	"./user/10.jpg": "./public/assets/images/user/10.jpg",
	"./user/11.png": "./public/assets/images/user/11.png",
	"./user/12.png": "./public/assets/images/user/12.png",
	"./user/14.png": "./public/assets/images/user/14.png",
	"./user/16.png": "./public/assets/images/user/16.png",
	"./user/2.jpg": "./public/assets/images/user/2.jpg",
	"./user/2.png": "./public/assets/images/user/2.png",
	"./user/3.jpg": "./public/assets/images/user/3.jpg",
	"./user/3.png": "./public/assets/images/user/3.png",
	"./user/4.jpg": "./public/assets/images/user/4.jpg",
	"./user/5.jpg": "./public/assets/images/user/5.jpg",
	"./user/6.jpg": "./public/assets/images/user/6.jpg",
	"./user/7.jpg": "./public/assets/images/user/7.jpg",
	"./user/8.jpg": "./public/assets/images/user/8.jpg",
	"./user/9.jpg": "./public/assets/images/user/9.jpg",
	"./user/user-dp.png": "./public/assets/images/user/user-dp.png",
	"./user/user.png": "./public/assets/images/user/user.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./public/assets/images sync recursive ^\\.\\/.*$";